import { useCallback, useState } from 'react';
// import {connections} from "./data";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { List } from "@mui/material";
import { ApiService } from 'app/servicesTwo/ApiService';
import { useParams } from "react-router-dom";
import ListItem from "./ListItem";

const ListRow = ({ data , setAddStudents, updateStudentList, classStudents, setSearchTerm}) => {
    const { id } = useParams()
    const Swal = useSwalWrapper();
    const toast = (variant, message) => {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: toast => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
        });

        Toast.fire({
            icon: variant,
            title: message,
        });
    };
    
    const maxLengthText = 20;
    const [itemsList, setItemsList] = useState(data);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false)

    const includeStudentToClass = useCallback((record, force = false ) => {
        try {
            setIsButtonDisabled(true)
            ApiService.post(`/turmas/${id}/aluno/${record.pessoa_id}`, { force })
            .then((response) => {
                let newArray = classStudents;
                record.curso_historico_id = response.data.curso_historico_id;
                record.status = response.data.status;
                record.atendeRequisitos = response.data.atendeRequisitos;
                newArray.push(record)
                updateStudentList(newArray);
                toast('success', 'Aluno adicionado com sucesso');
                setSearchTerm('')
                setIsButtonDisabled(false)
            })
            .catch((error) => {
                console.log('includeStudentToClass')
                console.log('error', error)

                if (error.response) {
                    if (error.response.status === 409 && error.response.data.code === 'CONFIRMATION_REQUIRED') {
                        setIsButtonDisabled(false);
                        Swal.fire({
                            title: 'Atenção',
                            text: 'O aluno não atende aos requisitos. Deseja adicionar mesmo assim?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Sim, adicionar!',
                            cancelButtonText: 'Cancelar'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                includeStudentToClass(record, true);
                            }
                        });
                        return;
                    }

                    toast('error', error.response.data.error);
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('error', error.message);
                }
            })
        } catch (err) {
            console.log(err);
        }

    }, [itemsList]);

    return (
            <List disablePadding>
                {
                    data.map((item, index) => (
                        !item?.naTurma &&
                        <ListItem item={item} key={index} includeStudentToClass={includeStudentToClass} isButtonDisabled={isButtonDisabled}/>
                    ))
                }
            </List>
    );
};

export default ListRow;
